import { LitElement, html, css } from '~/lib/bn-lit-element';

import { sharedStyles } from '../styles/shared-styles';
import { a2hs } from './a2hs';

export class AddToHomeScreenButton extends LitElement {
  constructor() {
    super();
    this.deferredInstallEvent = null;
    this._prompted = this._prompted.bind(this);
  }

  static get properties() {
    return {
      show: { type: Boolean },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: inline-block;
      }
    `];
  }

  render() {
    return html`<button class="add-button button button--contained" @click="${a2hs.prompt}" ?disabled="${!this.show}">Install</button>`;
  }

  connectedCallback() {
    super.connectedCallback();
    a2hs.addHandler(this._prompted);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    a2hs.removeHandler(this._prompted);
  }

  _prompted() {
    this.show = true;
  }
}

window.customElements.define('a2hs-button', AddToHomeScreenButton);
